import { render, staticRenderFns } from "./ParticipantSignatureRow.vue?vue&type=template&id=53d167fc&scoped=true"
import script from "./ParticipantSignatureRow.vue?vue&type=script&lang=js"
export * from "./ParticipantSignatureRow.vue?vue&type=script&lang=js"
import style0 from "./ParticipantSignatureRow.vue?vue&type=style&index=0&id=53d167fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d167fc",
  null
  
)

export default component.exports